/*
 * The languages a tenant's CONTENT is written in (docs/API.md → Enums, Language): the locales
 * tv-display ships. A LocalizedText holds one text per enabled language of the tenant.
 */
export enum Language {
    Sl = 'sl',
    En = 'en',
    De = 'de',
    It = 'it',
    Hr = 'hr',
    Hu = 'hu',
}

export const LANGUAGES: Language[] = [Language.Sl, Language.En, Language.De, Language.It, Language.Hr, Language.Hu]
